const SPACEBAR_KEY_CODE = 32;
const RETURN_KEY_CODE = 13;
const ESC_KEY_CODE = 27;
const UP_ARROW_KEY_CODE = 38;
const DOWN_ARROW_KEY_CODE = 40;
const TAB_KEY_CODE = 9;
const HOME_KEY_CODE = 36;
const END_KEY_CODE = 35;
export { SPACEBAR_KEY_CODE, RETURN_KEY_CODE, ESC_KEY_CODE, UP_ARROW_KEY_CODE, DOWN_ARROW_KEY_CODE, TAB_KEY_CODE, HOME_KEY_CODE, END_KEY_CODE };
//# sourceMappingURL=keyCodes.js.map